import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertDialogService } from 'src/app/Services/Alert/alert.service';
import { CommonService } from 'src/app/Services/Common/common.service';
import { HttpRequestService } from 'src/app/Services/Http/http-request.service';
import { PropertiesService } from 'src/app/Services/Properties/properties.service';
@Component({
  selector: 'app-onboarding',
  templateUrl: './onboarding.component.html',
  styleUrls: ['./onboarding.component.css']
})
export class OnboardingComponent implements OnInit {
  progressBarShow: boolean = false;
  WebAPImasteruri = this.property.WebAPIipAndPort.concat(this.property.BSSAPI);
  today = new Date();
  BranchList: any;
  OnboardingRequest_Form: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private property: PropertiesService,
    public commonService: CommonService,
    private http: HttpClient,
    private route: ActivatedRoute,
    private httpRequestService: HttpRequestService,
    private alert: AlertDialogService,
    private datePipe: DatePipe,
    private router: Router,
  ) { this.createForm(); }
  createForm() {
    this.OnboardingRequest_Form = this.formBuilder.group({

      TransID: [],
      EmployeeNumber: [],
      EmployeeName: [],
      Designation: [],
      Branch: [],
      DOJ: [],
      ReportingTo: [],
      ReportingToName: [],
      Email: [],
      EmailIntra: [],
      MobCountry: [],
      MobileNumber: [],


      isLaptop: [],
      // LaptopID
      isFormatted: [],
      isChrome: [],
      isBLISSWALL: [],
      isSophos: [],
      isMSOffice: [],
      isOutlookConfig: [],
      isTeams: [],
      isAnydesk: [],
      isUltaviewer: [],
      isAdobeReader: [],
      isFilehippo: [],
      BLISSRights: [],
      isDigitalSign: [],
      isBiometric: [],
      isDoorAccess: [],
      Note: [],
      // DepartmentID: [],
    });
  }
  Back() {
    this.router.navigate(['home/OnboardingList']);
  }
  ngOnInit() {
    this.branchCombo();
    this.OnboardingRequest_Form.get("DOJ").setValue(new Date());
    this.route.queryParams.subscribe(params => {
      if (params.TransID) {
        this.Clear();
        this.FetchData(params.TransID);
      }
    });
  }

  FetchData(TransID) {
    this.progressBarShow = true;
    this.GetData(TransID).then((list: any) => {
      this.progressBarShow = false;
      let headerDetails: any;
      headerDetails = list.result.Table[0];
      this.OnboardingRequest_Form.get("TransID").setValue(headerDetails.TransID);
      this.OnboardingRequest_Form.get("EmployeeNumber").setValue(headerDetails.EmployeeNumber);
      this.OnboardingRequest_Form.get("EmployeeName").setValue(headerDetails.EmployeeName);
      this.OnboardingRequest_Form.get("Designation").setValue(headerDetails.Designation);
      this.OnboardingRequest_Form.get("Branch").setValue(headerDetails.Branch);
      this.OnboardingRequest_Form.get("DOJ").setValue(headerDetails.DOJ);
      this.OnboardingRequest_Form.get("ReportingTo").setValue(headerDetails.ReportingTo);
      this.OnboardingRequest_Form.get("Email").setValue(headerDetails.Email);
      this.OnboardingRequest_Form.get("EmailIntra").setValue(headerDetails.EmailIntra);
      this.OnboardingRequest_Form.get("MobCountry").setValue(headerDetails.MobCountry);
      this.OnboardingRequest_Form.get("MobileNumber").setValue(headerDetails.MobileNumber);
      this.OnboardingRequest_Form.get("ReportingToName").setValue(headerDetails.ReportingToName);

      this.OnboardingRequest_Form.get("isLaptop").setValue(headerDetails.isLaptop);
      // this.OnboardingRequest_Form.get("LaptopID").setValue(headerDetails.LaptopID);
      this.OnboardingRequest_Form.get("isFormatted").setValue(headerDetails.isFormatted);
      this.OnboardingRequest_Form.get("isChrome").setValue(headerDetails.isChrome);
      this.OnboardingRequest_Form.get("isBLISSWALL").setValue(headerDetails.isBLISSWALL);
      this.OnboardingRequest_Form.get("isSophos").setValue(headerDetails.isSophos);
      this.OnboardingRequest_Form.get("isMSOffice").setValue(headerDetails.isMSOffice);
      this.OnboardingRequest_Form.get("isOutlookConfig").setValue(headerDetails.isOutlookConfig);
      this.OnboardingRequest_Form.get("isTeams").setValue(headerDetails.isTeams);
      this.OnboardingRequest_Form.get("isAnydesk").setValue(headerDetails.isAnydesk);
      this.OnboardingRequest_Form.get("isUltaviewer").setValue(headerDetails.isUltaviewer);
      this.OnboardingRequest_Form.get("isAdobeReader").setValue(headerDetails.isAdobeReader);
      this.OnboardingRequest_Form.get("isFilehippo").setValue(headerDetails.isFilehippo);
      this.OnboardingRequest_Form.get("BLISSRights").setValue(headerDetails.BLISSRights);
      this.OnboardingRequest_Form.get("isDigitalSign").setValue(headerDetails.isDigitalSign);
      this.OnboardingRequest_Form.get("isBiometric").setValue(headerDetails.isBiometric);
      this.OnboardingRequest_Form.get("isDoorAccess").setValue(headerDetails.isDoorAccess);
      this.OnboardingRequest_Form.get("Note").setValue(headerDetails.Note);
    });
  }

  GetData(TransID) {
    return new Promise((resolve, reject) => {
      this.httpRequestService.get(this.WebAPImasteruri + "/OnboardingRequest/Get_OnboardingRequest?TransID=" + TransID)
        .then((res: any) => {
          if (res.status == 200) {
            resolve(res);
          }
        }, (error) => {
          reject(error);
        });
    });
  }
  Clear() {
    this.OnboardingRequest_Form.reset();
    this.progressBarShow = false;
    this.OnboardingRequest_Form.get("DOJ").setValue(new Date());
  }

  public userParams(value) {
    return new Promise((res) => {
      res({ searchText: value, Type: 'All' });
    });
  }

  branchCombo() {
    this.http.get(this.property.WebAPIipAndPort.concat(this.property.BSSAPI) + '/branch/allbranchMasterList').subscribe((res: any) => {
      if (res.status == 200) {
        this.BranchList = res.result.Table;
      }
    });
  }

  Save() {
    var frmObj = this.OnboardingRequest_Form.getRawValue();
    frmObj = this.getFinalForm(frmObj);
    if (!frmObj.TransID) {
      this.alert.openSnackBar('Access Denied!', '1');
      return;
    }
    this.progressBarShow = true;
    var header = { 'Accept': 'application/json', 'Content-Type': 'application/json' }
    this.httpRequestService.post(this.WebAPImasteruri + "/OnboardingRequest/Update_OnboardingRequest", frmObj, header).then((response: any) => {
      this.progressBarShow = false;
      if (response.status == 200) {
        this.alert.openSnackBar(response.result.Table[0].Message, '1');
        this.Clear();
        this.Back();
      } else if (response.status == 400) {
        this.progressBarShow = false;
        this.alert.openSnackBar(response.result, '');
      }
    }, (error: any) => {
      this.progressBarShow = false;
      console.log('MiscJob Save Error Occured', error);
      this.alert.openSnackBar("Error", '0');
    });
  }
  getFinalForm(frmObj) {
    frmObj.ModifiedBy = this.property.userId;
    // frmObj.Branch = this.property.branchCode;
    frmObj.UpdatedBy = this.property.userId;
    if (!frmObj.TransID) {
      delete frmObj.TransID;
      frmObj.CreatedBranch = this.property.branchCode;
      frmObj.CreatedBy = this.property.userId;
    }
    if (!frmObj.EmployeeNumber) { delete frmObj.EmployeeNumber; }
    if (!frmObj.EmployeeName) { delete frmObj.EmployeeName; }
    if (!frmObj.Designation) { delete frmObj.Designation; }
    if (!frmObj.Branch) { delete frmObj.Branch; }
    if (!frmObj.DOJ) { delete frmObj.DOJ; } else { frmObj.JobDate = this.datePipe.transform(frmObj.JobDate, 'MM-dd-yyyy') }

    if (!frmObj.ReportingTo) { delete frmObj.ReportingTo; }
    if (!frmObj.Email) { delete frmObj.Email; }
    if (!frmObj.EmailIntra) { delete frmObj.EmailIntra; }
    if (!frmObj.MobCountry) { delete frmObj.MobCountry; }
    if (!frmObj.MobileNumber) { delete frmObj.MobileNumber; }

    if (!frmObj.isLaptop) { 
      frmObj.isLaptop = 0;
    } else {
      frmObj.isLaptop = 1; 
    }

    if (!frmObj.LaptopID) { 
      frmObj.LaptopID = 0;
    }
    if (!frmObj.isFormatted) { 
      frmObj.isFormatted = 0;
    } else {
      frmObj.isFormatted = 1; 
    }
    if (!frmObj.isChrome) { 
      frmObj.isChrome = 0;
    } else {
      frmObj.isChrome = 1; 
    }
    if (!frmObj.isBLISSWALL) { 
      frmObj.isBLISSWALL = 0;
    } else {
      frmObj.isBLISSWALL = 1; 
    }
    if (!frmObj.isSophos) { 
      frmObj.isSophos = 0;
    } else {
      frmObj.isSophos = 1; 
    }
    if (!frmObj.isMSOffice) { 
      frmObj.isMSOffice = 0;
    } else {
      frmObj.isMSOffice = 1; 
    }
    if (!frmObj.isOutlookConfig) { 
      frmObj.isOutlookConfig = 0;
    } else {
      frmObj.isOutlookConfig = 1; 
    }
    if (!frmObj.isTeams) { 
      frmObj.isTeams = 0;
    } else {
      frmObj.isTeams = 1; 
    }
    if (!frmObj.isAnydesk) { 
      frmObj.isAnydesk = 0;
    } else {
      frmObj.isAnydesk = 1; 
    }
    if (!frmObj.isUltaviewer) { 
      frmObj.isUltaviewer = 0;
    } else {
      frmObj.isUltaviewer = 1; 
    }
    if (!frmObj.isAdobeReader) { 
      frmObj.isAdobeReader = 0;
    } else {
      frmObj.isAdobeReader = 1; 
    }
    if (!frmObj.isFilehippo) { 
      frmObj.isFilehippo = 0;
    } else {
      frmObj.isFilehippo = 1; 
    }
    // if (!frmObj.BLISSRights) { 
    //   frmObj.BLISSRights = 0;
    // } else {
    //   frmObj.BLISSRights = 1; 
    // }
    if (!frmObj.isDigitalSign) { 
      frmObj.isDigitalSign = 0;
    } else {
      frmObj.isDigitalSign = 1; 
    }
    if (!frmObj.isBiometric) { 
      frmObj.isBiometric = 0;
    } else {
      frmObj.isBiometric = 1; 
    }
    if (!frmObj.isDoorAccess) { 
      frmObj.isDoorAccess = 0;
    } else {
      frmObj.isDoorAccess = 1; 
    }
    if (!frmObj.Note) { 
      delete frmObj.Note;
    }
    if (!frmObj.DepartmentID) { 
      frmObj.DepartmentID = 0;
    } 
    return frmObj;
  }



}
